import React from "react";
import useStyles from "./Styles";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import userActions from "../TechnicalView/actions";
// import appActions from "../app/actions";

import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import AllCharts from "./AllCharts";

// import useIsDevUrl from "hooks/useIsDevUrl";

const ChartView = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const {
    setChart,
    loadIrrigationDistricts,
    loadAgricultureDistrictWater,
    loadWaterDeliveries,
    loadCityMetrics,
    loadCities,
    loadEntityEntitlements,
  } = userActions();
  const { chart } = useSelector(
    (state) => state.technical_view
  );
  // const { setChartDrawerStateToClose } = appActions();
  // const isDevUrl = useIsDevUrl();

  // React.useEffect(() => {

  //   return () => {
  //     setChart("colorado_river_access");
  //   };
  // }, []);

  const componentMount = async () => {
    await loadIrrigationDistricts();
    await loadAgricultureDistrictWater();
    await loadWaterDeliveries();
    await loadCityMetrics(1); //as default, we will show the information for the first item in the dropdown menu
    await loadEntityEntitlements(1);
    await loadCities();
    const chart = location.pathname.split("/")[2];
    switch (chart) {
      case "map":
        setChart("colorado_river_access");
        history.push(`/public/map`);
        break;
      case "honeycomb":
        setChart("access_per_capita");
        history.push(`/public/honeycomb`);
        break;
      default:
    }
  }

  React.useEffect(componentMount, []);
  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        flexDirection: "column",
        height: 700,
        overflow: "hidden",
        overflowY: "scroll",
      }}
      className={classes.mapChartView}
    >
      {chart === "colorado_river_access" ? (
        <AllCharts map={true} />
      ) : chart === "access_per_capita" ? (
        <AllCharts map={false} />
      ) : (
        <AllCharts map={true} />
      )}
    </Box>
  );
};

export default ChartView;
